import { TitleEntry } from './titleEntry';

/**
 * Control has no sidebar to take tab names from, so this is the one place its
 * pages are named. Keep it in step with the Control routes in `App.tsx`; a
 * route with no entry here falls back to the bare workspace name.
 *
 * Store and chain names arrive as the URL token (`lidl_fulham_uk`); the pages
 * that load the record swap in its legible name through `useEntityTitle`.
 */
export const CONTROL_TITLE_ENTRIES: TitleEntry[] = [
  { path: '/stores', label: 'Stores' },
  {
    path: '/stores/:storeName/mod-eligibility',
    label: 'Mod eligibility',
    params: [{ name: 'storeName' }],
  },
  { path: '/stores/:storeName/aisle', label: 'Aisle', params: [{ name: 'storeName' }] },
  { path: '/chains/:chainName/pog-rules', label: 'POG rules', params: [{ name: 'chainName' }] },
  {
    path: '/chains/:chainName/pog-reset',
    label: 'Planogram resets',
    params: [{ name: 'chainName' }],
  },
  { path: '/pog-reset', label: 'POG reset' },
  { path: '/stores/:storeName/pog-reset', label: 'POG reset', params: [{ name: 'storeName' }] },
  { path: '/stores/:storeName/pog-reset/mods', label: 'Mods', params: [{ name: 'storeName' }] },
  {
    path: '/stores/:storeName/pog-reset/install-map',
    label: 'Install map',
    params: [{ name: 'storeName' }],
  },
  {
    path: '/stores/:storeName/planogram-health',
    label: 'Planogram health',
    params: [{ name: 'storeName' }],
  },
  {
    path: '/stores/:storeName/pog-reset/stats',
    label: 'Mapping accuracy',
    params: [{ name: 'storeName' }],
  },
  {
    path: '/stores/:storeName/pog-reset/:taskId',
    label: 'Reset task',
    params: [{ name: 'taskId', opaque: true }, { name: 'storeName' }],
  },
  {
    path: '/stores/:storeName/cameras',
    label: 'Cameras',
    params: [{ name: 'storeName' }],
  },
  { path: '/stores/:storeName', label: 'Store', params: [{ name: 'storeName' }] },
  {
    path: '/stores/:storeName/:deviceName',
    label: 'Camera',
    params: [{ name: 'deviceName' }, { name: 'storeName' }],
  },
  { path: '/tasks', label: 'Tasks' },
  { path: '/tasks/:taskId', label: 'Task', params: [{ name: 'taskId', opaque: true }] },
  {
    path: '/gt/audit/:gtSampleId',
    label: 'GT audit',
    params: [{ name: 'gtSampleId', opaque: true }],
  },
  {
    path: '/images/:imageId/audit',
    label: 'Image audit',
    params: [{ name: 'imageId', opaque: true }],
  },
  { path: '/embeddings', label: 'Embeddings' },
  { path: '/embeddings/detail', label: 'Embedding' },
  { path: '/embeddings/candidates', label: 'Candidates' },
  {
    path: '/embeddings/candidates/:imageId',
    label: 'Candidate',
    params: [{ name: 'imageId', opaque: true }],
  },
  { path: '/outs-selection/:imageId', label: 'OUTS', params: [{ name: 'imageId', opaque: true }] },
];
